'use client';

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { forgotPassword } from '../../redux/actions/authActions';

// Schéma de validation
const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Adresse email invalide')
    .required('Email requis')
});

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const { loading, error, message } = useSelector(state => state.auth);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await dispatch(forgotPassword(values.email));
      setEmailSent(true);
    } catch (error) {
      console.error('Erreur lors de la demande de réinitialisation :', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <h2 className="auth-title">Mot de passe oublié</h2>
      <p className="auth-subtitle">Saisissez votre adresse email pour recevoir un lien de réinitialisation</p>

      {error && (
        <div className="alert alert-danger">
          {error}
        </div>
      )}

      {emailSent || message ? (
        <div className="success-message">
          <div className="alert alert-success">
            <p>Si un compte existe avec cette adresse email, un lien de réinitialisation a été envoyé.</p>
            <p>Veuillez vérifier votre boîte de réception (et éventuellement vos spams).</p>
          </div>
          <div className="auth-links">
            <Link to="/login" className="btn btn-primary">
              Retour à la connexion
            </Link>
          </div>
        </div>
      ) : (
        <Formik
          initialValues={{ email: '' }}
          validationSchema={ForgotPasswordSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form className="auth-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <Field
                  type="email"
                  name="email"
                  id="email"
                  className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`}
                  placeholder="votre@email.com"
                />
                <ErrorMessage name="email" component="div" className="invalid-feedback" />
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={isSubmitting || loading}
              >
                {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
              </button>
            </Form>
          )}
        </Formik>
      )}

      <div className="auth-links">
        <p>
          Vous vous souvenez de votre mot de passe ?{' '}
          <Link to="/login" className="auth-link">
            Connexion
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;